import styled from 'styled-components'

export const ButtonStyle = styled.button`
  background: #d2d2d2;
  border-radius: 4px;
  height: 45px;
  display: inline-block;
  text-align: center;
  white-space: nowrap;
  border: 1px solid transparent;
  padding: 6px 12px;
  font-size: 19px;
  line-height: 1.5;
  font-weight: 400;
  font-family: calibri;
  cursor: pointer;
  margin-bottom: 20px;
  transition: all 0.15s ease-in-out;
`;
